module.exports = require("debug");